/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import SelectPills from 'loracoms/SelectPills';
import IntlMsg from 'lorautils/intl/IntlMsg';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  onChange: React.PropTypes.func.isRequired,
  plan: React.PropTypes.object,
  bsSize: React.PropTypes.string,
};

class DataDirSwitch extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
    };
    this.intlMsg = new IntlMsg(props.intl);
  }

  componentWillReceiveProps(nextProps) {
    const { plan } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  render() {
    const { onChange, bsSize } = this.props;
    const { plan } = this.state;

    if (plan.status !== 'success') {
      return <i className="fa fa-spinner fa-spin" />;
    }

    return (
      <SelectPills
        options={[
          {
            name: (
              <span>
                <i className="fa fa-long-arrow-up" />
                {this.intlMsg.msg('lora.datadir.up')}
              </span>
            ),
            value: 'up',
            active: true,
          },
          {
            name: (
              <span>
                <i className="fa fa-long-arrow-down" />
                {this.intlMsg.msg('lora.datadir.down')}
              </span>
            ),
            value: 'down',
          },
        ]}
        bsSize={bsSize}
        onChange={selected => onChange(selected[0])}
        disabled={plan.data.tier === 1}
      />
    );
  }
}


DataDirSwitch.propTypes = propTypes;

const mapStateToProps = state => ({
  plan: state.billing.plan,
});

export default connect(mapStateToProps, null)(injectIntl(DataDirSwitch));





// WEBPACK FOOTER //
// ./src/components/DataDirSwitch.jsx